import { AxiosResponse } from "axios";
import {apiGateway, api} from "../config";

import {IRowData, ITableSettingsLegacy} from "../../constants/Table/interfaces";
import {queryParamsToString} from "../../utils/requestHelpers/requestHelpers";

interface IActionSellerProduct {
    product: IRowData | IRowData[],
    sellerId: number
}

export interface IProductsRequest {
    sellerID: number|undefined,
    withStocks: boolean,
    withStocksSum: boolean,
    channels: string[],
    limit: number,
    page: number,
    order?: object,
    filter?: object
}

export interface IProductsFilter {
    id: number,
    name: string,
    code: string,
    isDeleted: boolean,
}

class sellerProductsService {

    async getSellerProducts(sellerId: number, data: ITableSettingsLegacy): Promise<AxiosResponse> {

        return api.post(`/api/${sellerId}/products`, data)
    }

    async getProducts(sellerId: number, data: ITableSettingsLegacy): Promise<AxiosResponse> {

        return api.post(`${process.env.REACT_APP_LEGACY_APP_URL}/api/internal/v1/products/get`, {seller: sellerId, ...data})
    }

    async changeSellerProduct(data: IActionSellerProduct): Promise<AxiosResponse> {
        return api.patch(`/api/${data.sellerId}/change-product`, data.product)
    }

    async deleteSellerProduct(data: IActionSellerProduct): Promise<AxiosResponse> {
        return api.post(`/api/${data.sellerId}/delete-product`, data.product)
    }

    async getTableProducts(data: IProductsRequest): Promise<AxiosResponse> {
        return api.post(`${process.env.REACT_APP_LEGACY_APP_URL}/api/v2/stocks/get`, data)
    }


    async getProductFilters(sellerId: number): Promise<AxiosResponse> {
        const query = queryParamsToString({seller: sellerId});
        return api.get(`${apiGateway.legacyPublicAPIv1}/product/filter/get?${query}`)
    }

    async updateProductAttributes(
        sellerID: number,
        productID: number,
        attributes: Partial<Record<'sku' | 'barcode' | 'name' | 'brand' | 'notes' | 'size', string>>,
    ): Promise<AxiosResponse> {
        return api.post(`${apiGateway.legacyPublicAPIv2}/${sellerID}/product/${productID}/attributes`, attributes);
    }

    async bulkUpdateProductAttributes(
        sellerID: number,
        items: Array<{
            productID: number;
        } & Partial<Record<'sku' | 'barcode' | 'name' | 'brand' | 'notes' | 'size', string>>>,
    ): Promise<AxiosResponse> {
        return api.post(`${apiGateway.legacyPublicAPIv2}/${sellerID}/products/attributes/bulk`, { items });
    }

}

export default new sellerProductsService();